import script from "./confirm-reassign-check-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./confirm-reassign-check-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__